import React, { Component } from 'react';

import SidebarLayout from 'components/layouts/SidebarLayout/SidebarLayout';
import UserProfileNavbar from 'components/navigation/UserProfileNavbar/UserProfileNavbar';

class UserProfile extends Component {
  render() {
    return (
      <div className="UserProfile">
        <SidebarLayout
          newLayout
          smHiddenDown
          sidebarComponent={<UserProfileNavbar />}
          children={this.props.children}
        />
      </div>
    );
  }
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/pages/student/Profile/index.js